import { render, staticRenderFns } from "./tab-quote-details-list.vue?vue&type=template&id=da40b4aa&scoped=true"
import script from "./tab-quote-details-list.vue?vue&type=script&lang=ts"
export * from "./tab-quote-details-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da40b4aa",
  null
  
)

export default component.exports